module.exports = __webpack_public_path__ + "img/f1-2-3.24d1fe4b.png";